import { ReactElement } from "react";
import {
    Article as ArticleIcon,
    Apps as AppsIcon,
    InsertChart as InsertChartIcon,
    AccountBox as AccountBoxIcon,
	Settings as SettingsIcon,
    LockReset as LockResetIcon,
    Logout as LogoutIcon,
    Domain as DomainIcon,
    Grading as GradingIcon,
    Construction as ConstructionIcon,
    Paid as MoneyIcon,
} from '@mui/icons-material';
import { OverridableComponent } from "@mui/material/OverridableComponent";
import { SvgIconTypeMap } from "@mui/material";
import GroupBrgList from "../pages/stock/group_brg/List";
import HargaBarangList from "../pages/sales/harga_barang/List";
import CustomerList from "../pages/sales/customer/List";
import BarangList from "../pages/stock/barang/List";
import KaryawanList from "../pages/global/karyawan/List";
import GudangList from "../pages/stock/gudang/List";
import MenuList from "../pages/global/menu/List";
import Logout from "../pages/Logout";

import { DivisiForm, DivisiList } from "../pages/global/divisi";
import { KategoriBrgForm, KategoriBrgList } from "../pages/stock/kategori_brg";
import Dashboard from "../pages/Dashboard";
import { UserForm, UserList } from "../pages/global/user";
import { PosisiForm, PosisiList } from "../pages/global/posisi";
import { GroupCustForm, GroupCustList } from "../pages/sales/group_cust";
import { EstimasiForm, EstimasiList } from "../pages/sales/estimasi";
import { SatuanForm, SatuanList } from "../pages/stock/satuan";
import { RoleForm, RoleList } from "../pages/global/role";
import { KaryawanForm } from "../pages/global/karyawan";
import { MenuForm } from "../pages/global/menu";
import { BarangForm } from "../pages/stock/barang";
import { GroupBrgForm } from "../pages/stock/group_brg";
import { GudangForm } from "../pages/stock/gudang";
import { HargaBarangForm } from "../pages/sales/harga_barang";
import { CustomerForm } from "../pages/sales/customer";
import { BookingServiceForm, BookingServiceList } from "../pages/sales/booking_service";
import { WorkorderForm, WorkorderFormDetail } from "../pages/sales/workorder";
import { InvoiceList } from "../pages/sales/invoice";
import { TerimaBayarForm, TerimaBayarList } from "../pages/sales/terima_bayar";

export type MenuGroupName = 
	"Dashboard" | 
	"Profil" | 
	"Umum" | 
	"Stok" | 
	"Servis"
	;
export type MenuCode = 
	"GLOBAL-DIVISI" |
	"GLOBAL-POSISI" |
	"GLOBAL-KARYAWAN" |
	"GLOBAL-USER" |
    "GLOBAL-ROLE" |
	"GLOBAL-MENU" |
	"STOCK-GUDANG" |
	"STOCK-GROUP-BRG" |
	"STOCK-KATEGORI-BRG" |
	"STOCK-SATUAN" |
	"STOCK-BARANG" |
	"SERVICE-GROUP-CUSTOMER" |
	"SERVICE-CUSTOMER" |
	"SERVICE-HARGA-BRG" |
	"SERVICE-ESTIMASI" |
	"SERVICE-BOOKING" |
	"SERVICE-BOOKING-WO" |
	"SERVICE-WORKORDER" |
	"SERVICE-INVOICE" |
	"SERVICE-TERIMA-BAYAR"
;
export type MenuTitle =
    "Divisi" |
	"Jabatan" |
	"Karyawan" |
	"User" |
	"Role" |
	"Menu" |
	"Gudang" |
	"Grup Barang" |
	"Kategori Barang" |
    "Satuan" |
	"Barang" |
	"Grup Customer" |
	"Customer" |
	"Harga Barang" |
    "Estimasi" |
    "Booking Service" |
    "Workorder" |
    "Workorder - Detail" |
    "Invoice" |
    "Terima Bayar"
;

export class MenuGroup {
    public readonly groupName: MenuGroupName;
    public readonly icon: OverridableComponent<SvgIconTypeMap<{}, "svg">> & {muiName: string};

    public constructor (
        groupName: MenuGroupName
    )
    {
        this.groupName = groupName;
        
        switch (groupName)
        {
            case "Dashboard":
                this.icon = InsertChartIcon;
                break;
            case "Profil":
                this.icon = AccountBoxIcon;
                break;
            case "Umum":
                this.icon = DomainIcon;
                break;
            case "Stok":
                this.icon = GradingIcon;
                break;
            case "Servis":
                this.icon = ConstructionIcon;
                break;
            default:
                this.icon = ArticleIcon;
                break;
        }
    }
}

export class MenuItemChild {
    public readonly code: MenuCode;
    public readonly title: string;
    public readonly path: string;
    public readonly component?: ReactElement;
    public readonly formPath?: string;
    public readonly formComponent?: ReactElement;
    public readonly isDefault: boolean;
    public readonly hidden: boolean;

    public constructor(
        code: MenuCode,
        title: string,
        path: string,
        component?: ReactElement,
        formPath?: string,
        formComponent?: ReactElement,
        isDefault: boolean = false,
        hidden: boolean = false
    ) {
        this.code = code;
        this.title = title;
        this.path = path;
        this.component = component;
        this.formPath = formPath;
        this.formComponent = formComponent;
        this.isDefault = isDefault;
        this.hidden = hidden;
    }
}

export class MenuItem {
    public readonly group: MenuGroup;
    public readonly groupName: MenuGroupName;
    public readonly id: string;
    public readonly title: string;
    public readonly path: string;
    public readonly icon?: OverridableComponent<SvgIconTypeMap<{}, "svg">> & {muiName: string};
    public readonly component?: ReactElement;
    public readonly isSubMenu: boolean;
    public readonly isOnlyLink: boolean;
    public readonly formPath?: string;
    public readonly formComponent?: ReactElement;
    public readonly children: MenuItemChild[];

    public constructor(
        groupName: MenuGroupName,
        id: string,
        title: string,
        path: string,
        icon?: OverridableComponent<SvgIconTypeMap<{}, "svg">> & {muiName: string},
        component?: ReactElement,
        isSubMenu: boolean = true,
        isOnlyLink: boolean = false,
        children: MenuItemChild[] = [],
        formPath?: string,
        formComponent?: ReactElement
    ) {
        this.group = new MenuGroup(groupName);
        this.groupName = groupName;
        this.id = id;
        this.title = title;
        this.icon = icon;
        this.path = path;
        this.component = component;
        this.isSubMenu = isSubMenu;
        this.isOnlyLink = isOnlyLink;
        this.formPath = formPath;
        this.formComponent = formComponent;
        this.children = children;
    }
}

export const Menu: MenuItem[] = [
	// Profil
	new MenuItem("Profil", "Ubah Password", "Ubah Password", "/change-password", LockResetIcon),
    new MenuItem("Profil", "Logout", "Logout", "/logout", LogoutIcon, <Logout />),
    // Dashboard
	new MenuItem("Dashboard", "Dashboard", "Dashboard", "/dashboard", undefined, <Dashboard />, false),
	// Umum
	new MenuItem("Umum", "Master", "Master", "/global-masters", AppsIcon, undefined, true, false, [
		new MenuItemChild("GLOBAL-DIVISI", "Divisi", "/divisi", <DivisiList />, "/divisi/form", <DivisiForm />, true),
		new MenuItemChild("GLOBAL-POSISI", "Jabatan", "/posisi", <PosisiList />, "/posisi/form", <PosisiForm />),
        new MenuItemChild("GLOBAL-KARYAWAN", "Karyawan", "/karyawan", <KaryawanList />, "/karyawan/form", <KaryawanForm />),
	]),
	new MenuItem("Umum", "Pengaturan", "Pengaturan", "/global-settings", SettingsIcon, undefined, true, false, [
		new MenuItemChild("GLOBAL-USER", "User", "/user", <UserList />, "/user/form", <UserForm />, true),
        new MenuItemChild("GLOBAL-ROLE", "Role", "/role", <RoleList />, "/role/form", <RoleForm />),
        new MenuItemChild("GLOBAL-MENU", "Menu", "/menu", <MenuList />, "/menu/form", <MenuForm />),
	]),
	// Stok
    new MenuItem("Stok", "Master", "Master", "/stock-masters", AppsIcon, undefined, true, false, [
        new MenuItemChild("STOCK-KATEGORI-BRG", "Kategori Barang", "/kategori-barang", <KategoriBrgList />, "/kategori-barang/form", <KategoriBrgForm />, true),
        new MenuItemChild("STOCK-GROUP-BRG", "Grup Barang", "/grup-barang", <GroupBrgList />, "/grup-barang/form", <GroupBrgForm />),
        new MenuItemChild("STOCK-SATUAN", "Satuan", "/satuan", <SatuanList />, "/satuan/form", <SatuanForm />),
        new MenuItemChild("STOCK-BARANG", "Barang", "/barang", <BarangList />, "/barang/form", <BarangForm />),
        new MenuItemChild("STOCK-GUDANG", "Gudang", "/gudang", <GudangList />, "/gudang/form", <GudangForm />),
	]),
	// Servis
	new MenuItem("Servis", "Master", "Master", "/service-masters", AppsIcon, undefined, true, false, [
        new MenuItemChild("SERVICE-GROUP-CUSTOMER", "Grup Customer", "/grup-customer", <GroupCustList />, "/grup-customer/form", <GroupCustForm />, true),
        new MenuItemChild("SERVICE-CUSTOMER", "Customer", "/customer", <CustomerList />, "/customer/form", <CustomerForm />),
        new MenuItemChild("SERVICE-HARGA-BRG", "Harga Barang", "/harga-barang", <HargaBarangList />, "/harga-barang/form", <HargaBarangForm />),
        new MenuItemChild("SERVICE-ESTIMASI", "Estimasi", "/estimasi", <EstimasiList />, "/estimasi/form", <EstimasiForm />),
    ]),
	new MenuItem("Servis", "Transaksi", "Transaksi", "/service-transactions", MoneyIcon, undefined, true, false, [
        new MenuItemChild("SERVICE-BOOKING", "Booking Service", "/book", <BookingServiceList />, "/book/form", <BookingServiceForm />, true),
        new MenuItemChild("SERVICE-BOOKING-WO", "Workorder", "/book/workorder", <></>, "/book/workorder/form", <WorkorderForm />, false, true),
        new MenuItemChild("SERVICE-WORKORDER", "Workorder - Detail", "/book/workorder/detail", <></>, "/book/workorder/detail/form", <WorkorderFormDetail />, false, true),
        new MenuItemChild("SERVICE-INVOICE", "Invoice", "/invoice", <InvoiceList />, undefined, undefined, false),
        new MenuItemChild("SERVICE-TERIMA-BAYAR", "Terima Bayar", "/terima-bayar", <TerimaBayarList />, "/terima-bayar/form", <TerimaBayarForm />, undefined, false),
    ]),
];
